import { render, staticRenderFns } from "./select-category.vue?vue&type=template&id=1b317304&"
import script from "./select-category.vue?vue&type=script&lang=js&"
export * from "./select-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports